import { Routes } from '@angular/router';
import { LayoutComponent } from './layout.component';
import { RegistrationComponent } from './components/registration/registration.component';
import { LoginComponent } from './components/login/login.component';
import { authGuard } from './gaurds/auth.guard';
import { authResolver } from './resolvers/auth.resolver';

export const routes: Routes = [
  { path: 'registration', component: RegistrationComponent },
  { path: 'login', component: LoginComponent },
  // Public: the link at the bottom of an alert email. The signed token is the credential, and the
  // reader may never have signed in on this browser.
  {
    path: 'unsubscribe',
    loadComponent: () => import('./components/unsubscribe/unsubscribe.component').then(m => m.UnsubscribeComponent),
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    resolve: { user: authResolver },
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./components/dashboard/dashboard.component').then(m => m.DashboardComponent),
      },
      {
        path: 'knowledge-base',
        loadComponent: () => import('./components/knowledge-base/knowledge-base.component').then(m => m.KnowledgeBaseComponent),
      },
      {
        path: 'settings',
        loadComponent: () => import('./components/settings/settings.component').then(m => m.SettingsComponent),
      },
      {
        path: 'usage',
        loadComponent: () => import('./components/usage/usage.component').then(m => m.UsageComponent),
      },
      {
        path: 'logs',
        loadComponent: () => import('./components/logs/logs.component').then(m => m.LogsComponent),
      },
      {
        path: 'logs/:sessionId',
        loadComponent: () => import('./components/logs/logs-detail.component').then(m => m.LogsDetailComponent),
      },
      {
        path: 'developer',
        loadComponent: () => import('./components/developer/developer.component').then(m => m.DeveloperComponent),
      },
      // Integrations: the places the chatbot talks to visitors, one page per kind.
      {
        path: 'integrations/widget',
        loadComponent: () => import('./components/widgets/widgets.component').then(m => m.WidgetsComponent),
      },
      {
        path: 'integrations/widget/:widgetId',
        loadComponent: () => import('./components/widgets/widget-detail/widget-detail.component').then(m => m.WidgetDetailComponent),
      },
      {
        path: 'integrations/whatsapp',
        loadComponent: () => import('./components/whatsapp/whatsapp.component').then(m => m.WhatsAppComponent),
      },
      // Tools: what the assistant can do — MCP servers and HTTP Actions.
      {
        path: 'tools/mcp-servers',
        loadComponent: () => import('./components/integrations/integrations.component').then(m => m.IntegrationsComponent),
      },
      {
        path: 'tools/http-actions',
        loadComponent: () => import('./components/actions/actions.component').then(m => m.ActionsComponent),
      },
      // {
      //   path: 'fine-tuning',
      //   loadComponent: () => import('./components/fine-tuning/fine-tuning.component').then(m => m.FineTuningComponent),
      // },
      {
        path: 'evaluate',
        loadComponent: () => import('./components/evaluate/evaluate.component').then(m => m.EvaluateComponent),
      },
      {
        path: 'profile',
        loadComponent: () => import('./components/profile/profile.component').then(m => m.ProfileComponent),
      },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: '**', redirectTo: 'dashboard' }
    ]
  }
];
